import type { WavespeedModelConfig } from '../types';
import { clampTo, hasImageInput } from '../../tools';

export const topazConfigs: Record<string, WavespeedModelConfig> = {
    'topaz/image/sharpen': {
        // https://wavespeed.ai/zh-CN/models/topaz/image/sharpen
        apiPath: '/topaz/image/sharpen',
        pollApiPath: '/predictions/${requestId}/result',
        enableTranslation: false,
        buildInput: (params) => {
            const { image_urls, providerOptions } = params;
            return {
                image: image_urls[0],
                // 可选参数
                model: clampTo(
                    providerOptions?.model || 'Standard',
                    ['Standard', 'Strong', 'Lens Blur', 'Lens Blur V2', 'Motion Blur', 'Natural', 'Refocus', 'Wildlife', 'Portrait'] as const,
                    'Standard',
                ),
                output_format: clampTo(
                    providerOptions?.output_format || 'jpeg',
                    ['jpeg', 'jpg', 'png', 'tiff', 'tif'] as const,
                    'jpeg',
                ),
            };
        },
    },
    'topaz/image/restore': {
        // https://wavespeed.ai/zh-CN/models/topaz/image/restore
        apiPath: '/topaz/image/restore',
        pollApiPath: '/predictions/${requestId}/result',
        enableTranslation: false,
        buildInput: (params) => {
            const { image_urls, providerOptions } = params;
            return {
                image: image_urls[0],
                // 可选参数
                model: clampTo(
                    providerOptions?.model || 'Dust-Scratch',
                    ['Dust-Scratch', 'Dust-Scratch V2'] as const,
                    'Dust-Scratch',
                ),
                output_format: clampTo(
                    providerOptions?.output_format || 'jpeg',
                    ['jpeg', 'jpg', 'png', 'tiff', 'tif'] as const,
                    'jpeg',
                ),
            };
        },
    },
    'topaz/image/lighting': {
        // https://wavespeed.ai/zh-CN/models/topaz/image/lighting
        apiPath: '/topaz/image/lighting',
        pollApiPath: '/predictions/${requestId}/result',
        enableTranslation: false,
        buildInput: (params) => {
            const { image_urls, providerOptions } = params;
            return {
                image: image_urls[0],
                // 可选参数
                model: clampTo(
                    providerOptions?.model || 'Adjust',
                    ['Adjust', 'Adjust V2', 'White Balance', 'Colorize'] as const,
                    'Adjust',
                ),
                output_format: clampTo(
                    providerOptions?.output_format || 'jpeg',
                    ['jpeg', 'jpg', 'png', 'tiff', 'tif'] as const,
                    'jpeg',
                ),
            };
        },
    },
    'topaz/image/denoise': {
        // https://wavespeed.ai/zh-CN/models/topaz/image/denoise
        apiPath: '/topaz/image/denoise',
        pollApiPath: '/predictions/${requestId}/result',
        enableTranslation: false,
        buildInput: (params) => {
            const { image_urls, providerOptions } = params;
            return {
                image: image_urls[0],
                // 可选参数
                model: clampTo(
                    providerOptions?.model || 'Normal',
                    ['Normal', 'Strong', 'Extreme'] as const,
                    'Normal',
                ),
                output_format: clampTo(
                    providerOptions?.output_format || 'jpeg',
                    ['jpeg', 'jpg', 'png'] as const,
                    'jpeg',
                ),
            };
        },
    },
};